<template>
    <div>
        <main-banner v-bind:image="'src/assets/images/' + image"></main-banner>
        <h2 class="blue--text mt-5">{{$t('pages.clients.wholesalers.title')}}</h2>
        <div class="mt-2 section-content" v-html="$t('pages.clients.wholesalers.about')"></div>
        <h2 class="blue--text mt-5">{{$t('pages.clients.wholesalers.products.title')}}</h2>
        <div class="mt-2 section-content" v-html="$t('pages.clients.wholesalers.products.content')"></div>
        <h2 class="blue--text mt-5">{{$t('pages.clients.wholesalers.contact.title')}}</h2>
        <div class="mt-2 section-content" v-html="$t('pages.clients.wholesalers.contact.content')"></div>
    </div>
</template>
<script>
    import MainBanner from '../sections/MainBanner.vue'

    export default {
        name: 'wholesalers',
        components: {
            'main-banner': MainBanner
        },
        data() {
            return {
                image: 'wholesalers.jpg',
                products: [
                    {
                        name: "Raporty standardowe",
                        icon: "show_chart",
                        image: "1.png"
                    },
                    {
                        name: "Rankingi",
                        icon: "format_list_numbered",
                        image: "2.png"
                    },
                    {
                        name: "Kostki",
                        icon: "border_all",
                        image: "3.png"
                    },
                    {
                        name: "Raporty niestandardowe",
                        icon: "multiline_chart",
                        image: "5.png"
                    }
                ]
            };
        }
    };
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// Wholesalers.vue?dce2ed34